import { getCurrentUser } from 'redux/query';

export const getUserZppCourseAttendances = (state) => {
  const user = getCurrentUser(state);
  return user?.zppCourseAttendances || [];
};
